<template>
  <div>
    <wc-data-box
      :title='toolbarData.title'
      :titleIcon='toolbarData.icon'
      :titleIconColor='toolbarData.color'
      :showEdit='!wo.archived && !wo.office_complete'
      @edit='editProblem'
    >
      <v-card-text v-html='wo.problem_description'></v-card-text>
      <v-card-text v-if='wo.instructions'>
        <div class='caption font-weight-bold mb-n4'>
          This WO instructions: (this is no longer used/editable but displayed here on older work orders for reference)
        </div>
        <br>
        {{ wo.instructions }}
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showEditDialog'
      :title='toolbarData.title'
      :icon='toolbarData.icon'
      :iconColor='toolbarData.color'
      @cancel='showEditDialog = false'
      @save='update'
    >
    <!-- will eventually replace this with tip tap?  but quick fix with editor for now -->
      <vue-editor :editor-toolbar='customToolbar' v-model='woCopy.problem_description'></vue-editor>
      <!-- <v-textarea outlined auto-grow v-model='woCopy.problem_description'></v-textarea> -->
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'wo-problem-description',
  props: {
    wo: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    showEditDialog: false,
    woCopy: {},
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ],
  }),
  computed: {
    toolbarData () {
      return {
        title: 'Problem Description',
        icon: 'mdi-help-circle-outline',
        color: 'orange'
      }
    }
  },
  methods: {
    editProblem () {
      this.woCopy = _.cloneDeep(this.wo)
      this.showEditDialog = true
    },
    update () {
      this.$emit('update', this.woCopy)
      this.showEditDialog = false
    }
  },
  components: {
    'vue-editor': VueEditor,
  }
}
</script>
